import { render, staticRenderFns } from "./FeatureBaseNavItem.vue?vue&type=template&id=cf38e00e"
import script from "./FeatureBaseNavItem.vue?vue&type=script&lang=js"
export * from "./FeatureBaseNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports